import { useCallback, useEffect, useState } from 'react'

const THEME_KEY = 'admin-theme'
const SIDEBAR_KEY = 'admin-sidebar-collapsed'

export type AdminThemeMode = 'light' | 'dark'

export function useAdminTheme() {
  const [mode, setMode] = useState<AdminThemeMode>(() =>
    localStorage.getItem(THEME_KEY) === 'dark' ? 'dark' : 'light',
  )

  useEffect(() => {
    document.documentElement.classList.toggle('dark', mode === 'dark')
    localStorage.setItem(THEME_KEY, mode)
  }, [mode])

  const toggle = useCallback(() => {
    setMode((m) => (m === 'dark' ? 'light' : 'dark'))
  }, [])

  return { mode, setMode, toggle }
}

export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(() =>
    localStorage.getItem(SIDEBAR_KEY) === '1',
  )

  useEffect(() => {
    localStorage.setItem(SIDEBAR_KEY, collapsed ? '1' : '0')
  }, [collapsed])

  const toggle = useCallback(() => {
    setCollapsed((c) => !c)
  }, [])

  return { collapsed, setCollapsed, toggle }
}
